'use client';

import React, { useState } from 'react';
import { Menu, Search, Bell, ChevronDown, RefreshCw } from 'lucide-react';

interface TopbarProps {
  onMobileMenuToggle: () => void;
}

export default function Topbar({ onMobileMenuToggle }: TopbarProps) {
  const [searchFocused, setSearchFocused] = useState(false);

  return (
    <header className="h-14 shrink-0 border-b border-border bg-card flex items-center gap-4 px-4 lg:px-6">
      {/* Mobile hamburger */}
      <button
        onClick={onMobileMenuToggle}
        className="lg:hidden text-muted-foreground hover:text-foreground transition-colors btn-press"
      >
        <Menu size={20} />
      </button>

      {/* Search */}
      <div
        className={`relative flex items-center gap-2 h-9 rounded-lg border bg-input px-3 text-sm transition-all duration-150 ${
          searchFocused
            ? 'border-primary shadow-[0_0_0_3px_rgba(79,110,247,0.12)] w-64'
            : 'border-border w-48 lg:w-56'
        }`}
      >
        <Search size={14} className="text-muted-foreground shrink-0" />
        <input
          type="text"
          placeholder="Search tasks, members…"
          className="flex-1 bg-transparent outline-none text-sm text-foreground placeholder:text-muted-foreground"
          onFocus={() => setSearchFocused(true)}
          onBlur={() => setSearchFocused(false)}
        />
        <kbd className="hidden sm:inline-flex items-center gap-1 text-[10px] text-muted-foreground font-mono bg-muted px-1.5 py-0.5 rounded">
          ⌘K
        </kbd>
      </div>

      <div className="flex-1" />

      {/* Sprint label */}
      <div className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-secondary text-secondary-foreground text-xs font-semibold">
        <span className="h-1.5 w-1.5 rounded-full bg-primary" />
        Sprint W35 · Aug 25 – Aug 31
      </div>

      {/* Last updated */}
      <button className="hidden sm:flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors btn-press">
        <RefreshCw size={13} />
        <span>Updated 2 min ago</span>
      </button>

      {/* Notifications */}
      <button className="relative text-muted-foreground hover:text-foreground transition-colors btn-press">
        <Bell size={20} />
        <span className="absolute -top-0.5 -right-0.5 h-4 w-4 rounded-full bg-primary text-primary-foreground text-[9px] font-bold flex items-center justify-center">
          3
        </span>
      </button>

      {/* User */}
      <button className="flex items-center gap-2 btn-press">
        <div className="h-8 w-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-semibold text-sm">
          MR
        </div>
        <ChevronDown size={14} className="text-muted-foreground hidden sm:block" />
      </button>
    </header>
  );
}